import { render, staticRenderFns } from "./scrap.vue?vue&type=template&id=cdbe5a10&scoped=true&"
import script from "./scrap.vue?vue&type=script&lang=js&"
export * from "./scrap.vue?vue&type=script&lang=js&"
import style0 from "./scrap.vue?vue&type=style&index=0&id=cdbe5a10&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbe5a10",
  null
  
)

export default component.exports